const VUE_APP_API_DORIS_URL = document.querySelector("html").getAttribute("api_doris_url");

export default VUE_APP_API_DORIS_URL